import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

const SubmitTroubleForm = async ( formData) => {
    try {
        const headers = {
           'Content-Type': 'application/json',
        };

        const response = await instance.post('HavingTrouble', formData, { headers });

        console.log('Response Data:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error submitting trouble form:', error);
        throw error;
    }
};

export default SubmitTroubleForm;
